import { GuardrailSettingsState, MaskingDemaskingMode, MaskingSettingsInput } from '../../../../../gamma-api';

import { DEFAULT_MASKING_SETTINGS } from './defaults';

export const isSettingsEnabled = (state?: GuardrailSettingsState): boolean =>
  (state ?? GuardrailSettingsState.Enabled) === GuardrailSettingsState.Enabled;

export const isMaskingEnabled = (masking?: MaskingSettingsInput): boolean =>
  (masking?.state ?? DEFAULT_MASKING_SETTINGS.state) === GuardrailSettingsState.Enabled;

export const isDemaskingEnabled = (masking?: MaskingSettingsInput): boolean =>
  isMaskingEnabled(masking) &&
  (masking?.demasking_mode ?? DEFAULT_MASKING_SETTINGS.demasking_mode) === MaskingDemaskingMode.WithDemasking;
